import {Authorizations, currentUserHasAuthorization} from "utils/authorizations";

/**
 * The attribute values export is only offered to members holding the
 * dedicated export authorization (admin only by default).
 */
export default function canExportAttributes() {
    return currentUserHasAuthorization(Authorizations.MARKETPLACE_ATTRIBUTE_EXPORT);
}
